const VALID_CANELD_PROVIDERS = ["Geotab", "Sunbelt", "Transflo"];

export enum CanadaEldOperatingSystems {
    Android = "Android",
    IOS = "IOS"
}

interface ICanadaEldDevice {
    id?: string;
    deviceType: string;
}

export function getCanadaRegistrationId(
    providerName: string,
    operatingSystem: CanadaEldOperatingSystems = CanadaEldOperatingSystems.Android,
    device: ICanadaEldDevice | null
): string {
    if (VALID_CANELD_PROVIDERS.indexOf(providerName) === -1) {
        return "";
    }

    if (providerName === "Transflo") {
        switch (operatingSystem) {
            case CanadaEldOperatingSystems.Android:
                return "6T34";
            case CanadaEldOperatingSystems.IOS:
                return "6T44";
            default:
                return "";
        }
    }

    let deviceType = device?.id === "NoDeviceId" ? "GO9" : device?.deviceType;
    switch (deviceType) {
        case "GO7":
        case "GO8":
        case "GO9": // GO9+ has it's own Registration IDs, but Device.DeviceType lumps GO9+ in with GO9
        case "GO9B":
            switch (operatingSystem) {
                case CanadaEldOperatingSystems.Android:
                    return "6T31";
                case CanadaEldOperatingSystems.IOS:
                    return "6T32";
                default:
                    return "";
            }
        case "GO10":
        case "GO10Lite":
            switch (operatingSystem) {
                case CanadaEldOperatingSystems.IOS:
                    return "6T72";
                case CanadaEldOperatingSystems.Android:
                    return "6T73";
                default:
                    return "";
            }
        default:
            return "";
    }
}
